import { AxiosResponse } from 'axios';
import { get } from 'lodash';

export type IResponseDataBody<DataModel = any> = AxiosResponse<{
    status: number,
    message: string,
    pageable: IPageable | null,
    data: DataModel,
}>;

export interface IPageable {
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    totalElements: number;
}

export interface IBodyApiUpdateStatusApt {
    appointmentId: string;
    status: number;
    reason: string;
}

export const getMessageError = (error: any, fallbackString = 'Request failed') => get(error, ['response', 'data', 'message'], fallbackString) || fallbackString;